import * as AuthAPI from './services/authAPI';
import './App.css';
import { Navigate, Route, Routes } from 'react-router-dom';
import AuthContext from './context/AuthContext';
import { useEffect, useState } from 'react';
import LoginPage from './pages/LoginPage';
import Sidebar from './components/SideBar';
import HomePage from './pages/HomePage';
import PrivateRoute from './components/PrivateRoute';
import RoutesPage from './pages/RoutesPage';
import RoutePage from './pages/RoutePage';
import RoutePlanningPage from './pages/RoutePlanningPage';
import BillingPage from './pages/BillingPage';
import HelpPage from './pages/HelpPage';
import BatchPage from './pages/BatchPage';
import UsersPage from './pages/UsersPage';
import LogisticPage from './pages/LogisticPage';
import UserPage from './pages/UserPage';
import SetPasswordPage from './pages/SetPasswordPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import AdminPage from './pages/AdminPage'


function App() {

    const [isAuthenticated, setIsAuthenticated] = useState(AuthAPI.isAuthenticated());
    const [user, setUser] = useState(() => AuthAPI.setup() || null);

    useEffect(() => {
        AuthAPI.onTokenChange((updatedUser) => {
            setUser(updatedUser);
        });
    }, []);

    const firstName = user?.firstName;
    const lastName = user?.lastName;
    const role = user?.role;
    const permissions = user?.permissions || [];

    const isSuperAdmin = role === 'ROLE_SUPER_ADMIN';
    const isManager = role === 'ROLE_MANAGER';
    const hasPermission = (perm) => isManager || permissions.includes(perm);
    const canAccessBilling = hasPermission('billing:read') || hasPermission('credentials:manage');
    const canAccessHelp = isManager || permissions.length > 0;

    const defaultRoute = isSuperAdmin ? "/admin" : "/";

    return (
        <AuthContext.Provider value={{
            isAuthenticated,
            setIsAuthenticated
        }}>
            {isAuthenticated &&
                <Sidebar
                    firstName={firstName}
                    lastName={lastName}
                    role={role}
                    hasPermission={hasPermission}
                    canAccessBilling={canAccessBilling}
                    canAccessHelp={canAccessHelp}
                    isSuperAdmin={isSuperAdmin}
                />
            }
            <div className={isAuthenticated ? "main-content" : ""}>
                <Routes>
                    <Route path="/login" element={isAuthenticated ? <Navigate to={defaultRoute} /> : <LoginPage />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    <Route path="/reset-password" element={<SetPasswordPage mode="reset" />} />
                    <Route path="/register" element={<SetPasswordPage mode="invitation" />} />
                    <Route element={<PrivateRoute />}>
                        {isSuperAdmin ? (
                            <>
                                <Route path="/admin" element={<AdminPage />} />
                                <Route path="*" element={<Navigate to="/admin" />} />
                            </>
                        ) : (
                            <>
                                <Route path="/" element={<HomePage />} />
                                {hasPermission('routes') && <>
                                    <Route path="/routes" element={<RoutesPage />} />
                                    <Route path="/routes/:id" element={<RoutePage />} />
                                    <Route path="/routes/planning" element={<RoutePlanningPage />} />
                                    <Route path="/routes/planning/:id" element={<BatchPage />} />
                                </>}
                                {canAccessBilling && <Route path="/billing" element={<BillingPage />} />}
                                {canAccessHelp && <Route path="/help" element={<HelpPage hasPermission={hasPermission} canAccessBilling={canAccessBilling} isManager={isManager} />} />}
                                {hasPermission('users:manager') && <>
                                    <Route path="/users" element={<UsersPage />} />
                                    <Route path="/users/:id" element={<UserPage />} />
                                </>}
                                {hasPermission('logistics') && <Route path="/logistic" element={<LogisticPage />} />}
                            </>
                        )}
                    </Route>
                </Routes>
            </div>
        </AuthContext.Provider>
    )
}

export default App;
